export enum IntimHaircut {
    Neat = 1,
    Depilation = 2,
    Natural = 3,
}